import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as newsAction from '../action/newsAction';


//Material-ui
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
//Add

import moment from 'moment';
//Func


//Dialog

//Icon
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import NotificationsIcon from '@material-ui/icons/Notifications';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      dialogNewsId: null,
      dialogNewsDate: null,
      dialogNewsComment: null,
    }

  }

  componentDidMount() {
    let datetime = new Date();
    if ((datetime - this.props.news.datetime) > (10*60*1000)) {
      this.props.newsListGet();
    }
  }

  _renderList(item, index) {
		return (
      <div key={index} className='box_outer'>
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            justifyContent:'start',
          }}
        >
          <NotificationsIcon style={{color:'#666'}}/>
          <div
            style={{
              width:'100%',
              padding:'3px',
              whiteSpace:'nowrap',
              overflow:'hidden',
              textOverflow:'ellipsis',
              color:'#666',
              cursor:'pointer',
            }}
            onClick={ () => this._dialogNews(item.news_id) }
          >
            <u>{moment(item.news_date).format("MM月DD日")} {item.news_title}</u>
          </div>

        </div>
      </div>
    );
  };

  _dialogNews(id) {
    let index = this.props.news.list.findIndex((v) => v.news_id === id);
		if (index >= 0) {
      this.setState({
        dialogNewsId: id,
        dialogNewsDate: this.props.news.list[index].news_date,
        dialogNewsComment: this.props.news.list[index].news_comment,
      })
		}
  }

	render() {
		return (
			<div id='news_block'>

        {
          (this.props.news.list.length > 0) && (
            <h2 align='center'>お知らせ</h2>
          )
        }
        {
          this.props.news.list.map(
            (value, index) => this._renderList(value, index)
          )
        }

        <Dialog
          fullScreen
          open={ (this.state.dialogNewsId !== null) ? true: false }
          onClose={ () => this.setState({dialogNewsId: null}) }
          TransitionComponent={Transition}
          style={{maxWidth:'600px', margin:'auto'}}
          scroll='paper'
        >
          <div style={{position:'fixed',top:'0px',left:'0px',width:'100%' ,zIndex:'101'}}>
            <div style={{maxWidth:'600px', margin:'auto', background:'#FFF'}} className='shadow'>
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  <IconButton
                    onClick={ () => this.setState({dialogNewsId: null}) }
                  >
                    <ArrowBackIosIcon />
                  </IconButton>
                  お知らせ
                </div>

              </div>

            </div>
          </div>
          <div
            style={{
              width:'100%',
              background:'#FFF',
              paddingTop:'50px',
            }}
          >
            <div style={{margin:'3%', color:'#333'}}>
              {moment(this.state.dialogNewsDate).format("YYYY年MM月DD日")}
            </div>
            <div style={{margin:'3%', whiteSpace: 'pre-line',color:'#333'}}>
              { this.state.dialogNewsComment }
            </div>
          </div>
        </Dialog>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		news: state.news,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...newsAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
